module.exports = __webpack_public_path__ + "img/Weapon_162.bc0d94c6.png";